export const BLOCK_NAME = 'blockName';
export const BLOCK_CATEGORY = 'category';
export const BLOCK_SUMMARY = 'summary';
export const EMAIL_ADDRESS = 'emailAddress';
export const TAGS = 'tags';
